import { GET } from './executer';
import apiServiceInstance from './apiService';

export interface Season {
  year: number;
  name: string;
}

class SeasonsService {
  /**
   * Fetch all seasons from the backend
   */
  async getAllSeasons() {
    return await apiServiceInstance.client.execute<Season[]>(
      GET,
      '/api/seasons'
    );
  }

  /**
   * Fetch a specific season by year
   */
  async getSeasonByYear(year: number) {
    return await apiServiceInstance.client.execute<Season>(
      GET,
      `/api/seasons/${year}`
    );
  }
}

const seasonsServiceInstance = new SeasonsService();
export default seasonsServiceInstance;

